import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Loading from '../../components/Loading';

import Toolbar from '../../components/chat/Toolbar.js';
import {setOpenChat,setCurrentTab} from '../../actions/Chat.js';
import Helmet from 'react-helmet';
import General from '../../modules/General';
import axios from 'axios';
import AskUpgrade from "../../components/AskUpgrade";
class Chat extends React.Component {
	constructor(props) {
		super(props);
		this.clickTab = this.clickTab.bind(this);
		this.getTemplates = this.getTemplates.bind(this);
		this.state = {
			askUpgrade:false,
			templates:[],
		}
	}

	componentDidMount() {
		if(this.props.router.params.user_id) {
			if(this.props.router.params.uid) {
				this.props.setOpenChat(this.props.router.params.uid,this.props.auth.user.id);
			}else{
				this.props.setCurrentTab(this.props.router.params.user_id);
			}
			
		}else{
			this.props.setCurrentTab(false);
		}
	}

    getTemplates() {
        this.setState({
            isLoading:true,
        });

        axios.get('/chat').then(res => {
            this.setState({
                isLoading:false,
                templates:res.data.templates,
            })
        });
    }

	componentWillMount() {
        General.loadScript('https://maps.google.com/maps/api/js?key=AIzaSyAYAu0_5_ANHFR6pLe0amZqPmt7uweOEBs');
        this.getTemplates();
	}

	componentDidUpdate() {
		if(this.props.general.settings.PACKAGE_CHAT != '1' && !this.state.askUpgrade ) {
			this.setState({askUpgrade:true});
		}
	}

	clickTab(val) {
		this.props.setCurrentTab(val);
		if(val == false) {
			this.props.router.push(General.Link('/chat/overview'));
		}else{
			this.props.router.push(General.Link('/chat/'+val));
		}
	}

	render() {

		if(!this.props.chat.initialized) {
			return <Loading error={false} />
		}

        if(this.props.general.settings.PACKAGE_CHAT != '1' && !this.state.askUpgrade ) {
            this.setState({askUpgrade:true});
        }

        const childrenWithProps = React.Children.map(this.props.children,
            (child) => React.cloneElement(child, {
                templates: this.state.templates,
				getTemplates:this.getTemplates
            })
        );

		return (
			<div className="full-height">
				<Helmet 
					title="Chat | Crall.io" 
				/>
				<Toolbar isOnline={this.props.chat.isOnline} setCurrentTab={this.clickTab} currentTab={this.props.chat.currentTab} me={this.props.auth.user} users={this.props.general.users} />

				<div id="chat" className="chat-wrapper">
					{childrenWithProps}
				</div>

			</div>
		);
	}
}



const mapStateToProps = (state) => {
	return {
		general:state.general,
		auth:state.auth,
		chat:state.chat
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setOpenChat,setCurrentTab},dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(Chat)



// WEBPACK FOOTER //
// ./containers/chat/Chat.js